
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface CallToActionProps {
  setSelectedTool: (tool: string) => void;
}

const CallToAction = ({ setSelectedTool }: CallToActionProps) => {
  const navigate = useNavigate();

  const handleToolSelect = (tool: string) => {
    // Navigate to the hash and then set the selected tool
    navigate(`/apologetics#${tool}`);
    setSelectedTool(tool);
  };

  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.5 }}
      className="bg-white py-12 mb-10 rounded-xl"
    >
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-playfair font-bold mb-4 text-gray-900">
          Ready to Deepen Your Faith?
        </h2>
        <p className="text-gray-600 mb-8 mx-4">
          The Apologetics Suite gives you instant, reliable answers for your toughest questions about
          God, faith, and Scripture. Start exploring now.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Button
            variant="gold"
            className="px-6"
            onClick={() => handleToolSelect("biblical-defense")}
          >
            Explore Theology Answers <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
          <Button
            variant="outline"
            className="border-heaven-gold text-heaven-gold hover:bg-heaven-gold/5"
            onClick={() => handleToolSelect("atheism")}
          >
            Address Atheism <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
      </div>
    </motion.section>
  );
};

export default CallToAction;
